import React from 'react';
import { MFBeaconModal } from '../Beacon/BeaconComponents';

const modalDescription = `Contribution limits were unable to be validated. Please check the
investment amount before proceeding.`;

const ContribLimitFailModal = () => {
  return (
    <MFBeaconModal scale="mini" open>
      <div className="beacon-modal__description">{modalDescription}</div>
    </MFBeaconModal>
  );
};

export default ContribLimitFailModal;
